import moment from 'moment';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectSearch } from '../../store/selectors/search';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import Icon from '../Icon';
import Label from '../Label';
import Overlay from '../Overlay';
import Search from '../Search';
import Table, { Hidden } from '../Table';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import CommonIssueForm from '../CommonIssueForm';
import { clearFndFormData, setFndFormData } from '../../store/actions/fndForm';
import CommonIssuesView from './CommonIssuesView';
import { Link } from 'react-router-dom';

class CommonIssuesTable extends Component {
  state = {
    showOverlay: false,
    showIssueOverlay: false,
    issueData: {}
  }
  render() {

    const { commonIssues,  onSaveCommonIssue, onDeleteCommonIssue, onSearch, search,breadcrumb, onSetFndFormData, onClearFndFormData} = this.props;

    return (
      <>
       <Actions compact>
          <Search
            size="small"
            placeholder="Search Common Issues..."
            onChange={onSearch}
          />
          <Button
            color="teal"
            label="Add Common Issue"
            onClick={() => {onClearFndFormData(); this.setState({ showOverlay: true })}}
            icon={(
              <Icon
                glyph="wrench"
                weight="light"
                size="small"
              />
            )}
            size="small"
          />
           
        </Actions>
        
        {commonIssues && commonIssues.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Description',
                  sortable: true,
                  cell: data => (
                    <Link
                      onClick={() => this.setState({ showIssueOverlay: true, issueData: data})}
                    >
                   {data.description}
                   </Link>
                  )
                },
                 {
                  xsHide: true,
                  label: 'Type',
                  cell: data => data.issueTypeName
                }, 
                {
                 // xsHide: true,
                  label: 'Asset',
                  cell: data => data.itemName
                },
                {
                  // xsHide: true,
                  label: 'Submitted By',
                  cell: data => data.userName
                },
                 {
                  xsHide: true,
                  label: 'Submitted',
                  cell: data =>
                   {
                    return (
                      <Label
                        color={'teal'}
                        label={moment(data.createdOn).format('MM/DD/YYYY')}
                      />
                    )
                  }
                },
                {
                  cell: data => (
                    <Hidden>
                        <Button
                        color="semantic"
                        label={(
                          <Icon
                            glyph="pencil"
                            weight="light"
                          />
                        )}
                        onClick={() => {
                          this.setState({ showOverlay: true})
                          onClearFndFormData();
                          onSetFndFormData({...data, attachment: data.attachment ? JSON.parse(data.attachment) : []})
                        }}
                      />
                      <Button
                        color="semantic"
                        onClick={ e =>
                          window.confirm(`Are you sure you want to delete common issue?`)&& onDeleteCommonIssue(data.id)}
                        label={(
                          <Icon
                            glyph="trash"
                            weight="light"
                          />
                        )}
                      />
                    </Hidden>
                      )
                }
              ]}
              data={commonIssues}
            />
          </>
          
        ) : (
          <Empty
            direction="ttb"
            headline={"Your common issues inbox is empty"}
            strapline={''}
            searchIsActive={search && search.commonIssues ? search.commonIssues : ''}
            cta={ (
              <Button
                color="teal"
                label="Add Common Issue"
                onClick={() => {onClearFndFormData();this.setState({ showOverlay: true })}}
                icon={(
                  <Icon
                    glyph="wrench"
                    weight="light"
                    size="small"
                  />
                )}
                size="small"
              />
            )}
            image={(
              <img
                alt="Your common issues inbox is empty"
                src="/assets/empty/service-requests.svg"
              />
            )}
          />
        )}
        <Overlay
          showOverlay={this.state.showOverlay}
          content={(
            <CommonIssueForm
              onClose={() => this.setState({showOverlay:false})}
              onSaveCommonIssue={onSaveCommonIssue}
              breadcrumb={breadcrumb}
            />
          )}
        />
         <Overlay
          showOverlay={this.state.showIssueOverlay}
          content={(
            <CommonIssuesView
              data={this.state.issueData}
              onClose={() => this.setState({showIssueOverlay:false})}
            />
          )}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  search: selectSearch(state),
  user:selectAuthenticatedUser(state),
  loader: selectLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetFndFormData: setFndFormData,
  onClearFndFormData: clearFndFormData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommonIssuesTable);
